export const OPEN_APPS_ID = [1, 14, 25, 35, 54]
